import { FC } from 'react'
import { Typography } from '@mui/material'

type LoadedPageRightTitleProps = {
  text: string
}

const LoadedPageRightTitle: FC<LoadedPageRightTitleProps> = ({ text }) => {
  return (
    <Typography variant="h1" sx={{ fontSize: '2em' }}>
      {text}
    </Typography>
  )
}

export default LoadedPageRightTitle
